export default "__VITE_ASSET__BixgpsOL__"